import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "@/App.css";
import "@/V14Overrides.css";
import { DashboardShell } from "@/components/DashboardShell";
import StatusPage from "@/pages/StatusPage";
import PerformancePage from "@/pages/PerformancePage";
import TradeHistoryPage from "@/pages/TradeHistoryPage";
import AutoTradingPage from "@/pages/AutoTradingPage";
import UserManagementPage from "@/pages/UserManagementPage";
import UserTradingDetailPage from "@/pages/UserTradingDetailPage";

export default function App() {
  return (
    <BrowserRouter>
      <DashboardShell>
        <Routes>
          <Route path="/" element={<StatusPage />} />
          <Route path="/performance" element={<PerformancePage />} />
          <Route path="/trade-history" element={<TradeHistoryPage />} />
          <Route path="/users" element={<UserManagementPage />} />
          <Route path="/users/:userId" element={<UserTradingDetailPage />} />
          <Route path="/auto-trading" element={<AutoTradingPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </DashboardShell>
    </BrowserRouter>
  );
}
